import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const SaveAsDraftIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 17"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M4.75 0.75L15.75 0.749999C16.3023 0.749999 16.75 1.19771 16.75 1.75L16.75 15.75C16.75 16.3023 16.3023 16.75 15.75 16.75L1.75 16.75C1.19772 16.75 0.750002 16.3023 0.750002 15.75L0.75 1.75C0.75 1.19772 1.19771 0.75 1.75 0.75L4.75 0.75ZM4.75 0.75L12.75 0.749999L12.75 4.75L4.75 4.75L4.75 0.75ZM4.75 9.75L12.75 9.75L12.75 16.75L4.75 16.75L4.75 9.75Z"
      stroke={color}
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </Svg>
);

SaveAsDraftIcon.displayName = 'SaveAsDraftIcon';
